import React from 'react';
import styled from '@emotion/styled';

const ListItem = styled.li`
  padding: 15px 0;
  border-bottom: 1px solid #82bae5;

  :first-of-type {
    padding-bottom: 0px;
    :after {
      content: '';
      display: block;
      clear: both;
    }
  }
`;

const Action = styled.a`
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  float: left;
  color: #fff;
  padding-bottom: 15px;
  user-select: none;

  :hover {
    text-decoration: none;
    border-bottom: 4px solid #fff;
    padding-bottom: 11px;
  }

  :last-of-type {
    float: right;
  }
`;

{
  /* Internationalise here */
}
const UserActions = () => {
  return (
    <ListItem>
      <Action href="/account/myprofile">My Profile</Action>
      <Action href="/account/logout">Log Out</Action>
    </ListItem>
  );
};

export { UserActions, UserActions as default };
